import withSSRModel from "hoc-lib/ssrModelMapper"
import { withSpacing } from "hoc-lib/spacing"
import StoryCarousel from "./StoryCarousel"

const WrappedComponent = withSSRModel(
  withSpacing({ useRebrandedspacingColor: true })(StoryCarousel),
)

// Component has to be mapped by the consumer
// Config has to be imported from constants-lib and passed to the MapTo function by the consumer
export default WrappedComponent
